export const INIT_NESTED_REDUCERS = 'Core/InitNestedReducers' as const;
export const CLEAN_NESTED_REDUCERS = 'Core/CleanNestedReducers' as const;
